import { DEFAULT_PREFIX_PHONE } from '@/constants';
import type { Address } from '@/modules/cart/domain/Cart';
import { IdentificationDocumentTypes } from '@/modules/shared/types/IdentificationDocumentType';

const { DNI, RUT } = IdentificationDocumentTypes;

export const mapShippingAddressToFormValues = (
  shippingAddress?: Address,
  isDniEnabled?: boolean
) => {
  if (shippingAddress?.region === 0 || !shippingAddress?.commune) {
    return undefined;
  }

  return {
    region: shippingAddress?.region,
    commune: shippingAddress?.commune,
    firstName: shippingAddress?.firstName,
    lastName: shippingAddress?.lastName,
    email: shippingAddress?.email,
    phone: shippingAddress?.phone,
    customerRut:
      shippingAddress?.customerRut || shippingAddress?.documentID || '',
    documentType:
      isDniEnabled && shippingAddress?.documentType
        ? shippingAddress?.documentType
        : RUT,
    documentID:
      isDniEnabled && shippingAddress?.documentType === DNI
        ? shippingAddress?.documentID
        : '',
    'terms-and-cons': false,
    'prefix-phone': DEFAULT_PREFIX_PHONE
  };
};
